import React from 'react';
import { IconStar, IconStarFilled } from 'takeat-design-system-ui-kit';
import { StarContainer, StarsComponentContainer } from './styles';

export const StarsComponent = ({ max = 5, value }) => {
  return (
    <StarsComponentContainer>
      {[...Array(max)].map((_, index) => {
        const percentage = (value - index) * 14;

        return (
          <StarContainer key={index} percentage={percentage}>
            <IconStar />
            {index < value && <IconStarFilled className="filled" />}
          </StarContainer>
        );
      })}
    </StarsComponentContainer>
  );
};
